import { useMediaQuery } from "@/hooks/ui";

/**
 * What the desktop live-agent stage has room for at the current viewport
 * width. The columns are: rail gutter 272, genie 660 (620 + padding),
 * transcript 560 shrinking to 360, shared links 400 shrinking to 280, with
 * 24px gaps and 24px of frame padding either side.
 */
export interface DesktopStageFit {
  /** Rail gutter + genie + a side column (transcript or shared links). */
  railBesideSideColumn: boolean;
  /** Rail gutter + genie + the matching spacer, with no side column open. */
  railGutters: boolean;
  /** The full-size genie column next to a side column at its narrowest. */
  fullGenieBesideSideColumn: boolean;
}

export function useDesktopStageFit(): DesktopStageFit {
  return {
    railBesideSideColumn: useMediaQuery("(min-width: 1600px)"),
    railGutters: useMediaQuery("(min-width: 1300px)"),
    fullGenieBesideSideColumn: useMediaQuery("(min-width: 1100px)"),
  };
}
